import { useNavigate } from "@tanstack/react-router";
import { Button } from "../components/ui/button/button";

export default function NotFound() {
	const navigate = useNavigate();

	return (
		<div className="flex flex-col items-center justify-center min-h-screen p-4 text-center">
			<h1 className="text-6xl font-bold text-gray-900 mb-4">404</h1>
			<h2 className="text-2xl font-semibold text-gray-700 mb-6">
				Page Not Found
			</h2>
			<p className="text-gray-600 mb-8 max-w-md">
				The page you're looking for doesn't exist or has been moved.
			</p>
			<Button
				onClick={() => navigate({ to: "/", search: { promo: undefined } })}
				className="px-6 py-2"
			>
				Go Back Home
			</Button>
		</div>
	);
}
